import { assertNever } from '@/coreDomainsModule/assertNever';
import { HeaderModifiableTableType } from '@/coreDomainsModule/table';

/**
 * テーブルの種類から編集可能なヘッダーのリストを返す
 */
export class GetModifiableHeaderKeysUseCase {
  /**
   * テーブルの種類から編集可能なヘッダーのリストを返す
   * @param tableType - テーブルのタイプ(ヘッダー編集に対応しているもの)
   * @returns - 編集可能なヘッダーのリスト
   */
  public static Execute(tableType: HeaderModifiableTableType) {
    switch (tableType) {
      case 'trash':
        return [
          'TrashBinWarehouseNumber',
          'TrashBinWarehouse',
          'TrashBinSupplierNumber',
          'TrashBinSupplierName',
          'TrashBinBusinessNumber',
          'TrashBinBusinessName',
          'TrashBinPackage',
          'TrashBinUnit',
          'TrashBinCustomerNumber',
          'TrashBinCustomerName',
          'TrashBinDeliveryDestinationNumber',
          'TrashBinDeliveryDestinationName',
          'TrashBinManufacturer',
          'TrashBinEndUser',
          'TrashBinSupplierForecastResponsibleUser',
          'TrashBinCustomerForecastResponsibleUser',
        ];
      case 'firmOrderTable':
        return [
          'OrderDate',
          'aggregateBusinessId',
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'businessNumber',
          'businessName',
          'package',
          'unit',
          'OrderGroupName',
          'OrderInvoiceNumber',
          'OrderDestinationName',
          'manufacturer',
          'OrderNumber',
          'OrderIssuedNumber',
          'supplierForecastResponsibleUser',
        ];
      case 'forecastForReceiptAllBusinessTable':
        return [
          'ForecastForReceiptStaffFull',
          'ForecastForReceiptName',
          'ForecastForReceiptResponsibleUser',
          'supplierNumber',
          'supplierName',
          'manufacturer',
          'businessNumber',
          'businessName',
          'package',
          'unit',
          'warehouseNumber',
          'warehouse',
          'endUser',
          'customerNumber',
          'customerName',
          'salesDestinationNumber',
          'salesDestinationName',
          'ForecastForReceiptReceiveDate',
        ];
      case 'notExportedOrderTable':
        return [
          'OrderDate',
          'aggregateBusinessId',
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'businessNumber',
          'businessName',
          'package',
          'unit',
          'manufacturer',
          'OrderGroupName',
          'OrderInvoiceNumber',
          'OrderDestinationName',
          'OrderNumber',
          'OrderIssuedNumber',
          'supplierForecastResponsibleUser',
        ];
      case 'orderManageTable':
        return [
          'OrderControlWarehouseNumber',
          'OrderControlWarehouse',
          'OrderControlBusinessNumber',
          'OrderControlBusinessName',
          'OrderControlSupplierNumber',
          'OrderControlSupplierName',
          'OrderControlPackage',
          'OrderControlUnit',
          'OrderControlManufacturer',
          'OrderControlLastCheckedAt',
          'OrderControlAggregateBusinessResponsibleUsers',
          'OrderControlCustomerName',
          'OrderControlSalesDestinationName',
          'OrderControlLeadTime',
          'OrderControlStdInventoryIndex',
        ];
      case 'supplierForecastAllBusinessTable':
        return [
          'supplierForecastStaff',
          'businessId',
          'supplierNumber',
          'supplierName',
          'manufacturer',
          'businessNumber',
          'businessName',
          'package',
          'unit',
          'warehouseNumber',
          'warehouse',
          'customerNumber',
          'customerName',
          'salesDestinationNumber',
          'salesDestinationName',
          'supplierForecastUpdateAt',
        ];
      case 'unmanagedBusinessTypeAnnounce':
        return [
          'inputDate',
          'fileName',
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'businessNumberNamedByUser',
          'businessName',
          'package',
          'unit',
          'customerNumber',
          'customerName',
          'deliveryDestinationNumber',
          'deliveryDestinationName',
        ];
      case 'unmanagedBusinessTypeArrival':
        return [
          'arrivalAmount',
          'inputDate',
          'fileName',
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'manufacturer',
          'businessNumberNamedByUser',
          'businessName',
          'package',
          'unit',
        ];
      case 'unmanagedBusinessTypeInventory':
        return [
          'inventory',
          'inputDate',
          'fileName',
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'manufacturer',
          'businessNumberNamedByUser',
          'businessName',
          'package',
          'unit',
        ];
      case 'unmanagedBusinessTypeSalesResult':
        return [
          'saleQuantity',
          'inputDate',
          'fileName',
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'businessNumberNamedByUser',
          'businessName',
          'package',
          'unit',
          'endUser',
          'customerNumber',
          'customerName',
          'deliveryDestinationNumber',
          'deliveryDestinationName',
        ];
      case 'deletionBusinessTable':
        return [
          'warehouseNumber',
          'warehouse',
          'supplierNumber',
          'supplierName',
          'businessNumber',
          'businessName',
          'package',
          'unit',
          'customerNumber',
          'customerName',
          'salesDestinationNumber',
          'salesDestinationName',
          'manufacturer',
          'endUser',
          'supplierForecastResponsibleUser',
          'customerForecastResponsibleUser',
        ];
      case 'customerForecastDiffLastMonth':
        return [
          'ForecastForReceiptStaff',
          'supplierNumber',
          'supplierName',
          'manufacturer',
          'businessNumber',
          'businessName',
          'package',
          'unit',
          'warehouseNumber',
          'warehouse',
          'endUser',
          'customerNumber',
          'customerName',
          'salesDestinationNumber',
          'salesDestinationName',
          'customerForecastUpdateAt',
        ];
      default:
        assertNever(tableType);
    }
  }
}
